import { BlogType } from "../../../Types/types";
import { format } from "date-fns";
import { Link } from "react-router-dom";

interface BlogProps {
  blog: BlogType;
}

// const delBlog = async (
//   blogId: string,
//   setBlogs: React.Dispatch<React.SetStateAction<BlogType[]>>
// ) => {
//   if (!window.confirm("Are you sure you want to delete this blog?")) {
//     return;
//   }

//   try {
//     const response = await deleteBlog(blogId);
//     if (response.status === false) {
//       console.log("Job deletion failed:", response.response?.data.message);
//     } else {
//       setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog._id !== blogId));
//       console.log("Blog deleted successfully:");
//       toast.success("Blog deleted successfully");
//     }
//   } catch (error) {
//     toast.error("Error deleting Blog");
//     console.error("Error deleting Blog:", error);
//   }
// };

const RecentBlog = ({ blog }: BlogProps) => {
  return (
    <div className="relative">
      <Link
        to={`/blog/${blog.slug}`}
        state={{ blog }}
        onClick={() => window.scrollTo(0, 0)}
        className="flex"
      >
        <div className="overflow-hidden group realtive rounded-2xl w-full h-full top-1">
          <img
            className="object-cover group-hover:scale-125 transition-all duration-500 w-full max-h-[400px]"
            src={`https://admin.techqilla.com${blog.image.url}`}
            alt={blog.imageAlt}
          />
          <div className="bg-gradient-to-t from-secondary to-transparent h-full w-full absolute top-0 z-10 rounded-2xl"></div>
          <div className="relative sm:absolute w-full h-full bottom-0 py-4 flex flex-col justify-end px-4 sm:px-8 z-20">
            <p className="text-white mb-2 sm:mb-4 py-2 px-3 bg-white/50 flex items-center self-start rounded-3xl text-sm sm:text-base">
              {blog.author} • {format(new Date(blog.createdAt), "dd MMM yyyy")}
            </p>
            <div className="sm:mb-3 text-white text-lg sm:text-4xl montserrat-semibold">
              {blog.title.split(" ").slice(0, 8).join(" ")}...
            </div>
            <div className="flex justify-between cursor-pointer  apply underline-offset-4 text-white/40 transition-all duration-400">
              <p className="text-sm sm:text-lg transition-all montserrat-regular duration-400">
                {blog.description.split(" ").slice(0, 12).join(" ")}...
              </p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default RecentBlog;
